export { default, getStaticProps } from "./login"